import type { Event_Entry } from '@/types/graphql';
import { formatDate } from '@/utils/dateFormat';

interface ShowDateTimeProps {
    event: Event_Entry;
    locale: string;
}

/**
 * Displays the date and time of a show.
 * Uses the venue's timezone (Europe/Amsterdam) to ensure consistent display
 * regardless of the user's local timezone.
 */
export default function ShowDateTime({ event, locale }: ShowDateTimeProps) {
    const startDate = event.eventProgramStart;
    const endDate = event.eventProgramEnd;

    if (!startDate) return null;

    const formattedStartDate = formatDate.dayMonthYear(startDate, locale);
    const formattedStartTime = formatDate.time(startDate, locale);
    const formattedEndTime = formatDate.time(endDate || startDate, locale);

    return (
        <div>
            {formattedStartDate}
            <br />
            <span className="text-sm">
                {formattedStartTime} - {formattedEndTime}
            </span>
        </div>
    );
}
